import React from "react";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import { Link } from "react-router-dom";

class OptionCardsPage extends BasePage {
  others() {
    this.navigateTo("/others");
  }
  render() {
    const isWalkIn = true;
    // if (true) {
    //   return this.navigateTo("/");
    // }
    return (
      <>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="d-flex flex-column align-items-center">
            <img
              src="/lgslogo.png"
              alt="lgs logo"
              style={{ width: "350px", height: "200px", marginBottom: "30px" }}
            />
            <p
              className="fs-7 text-muted text-center"
              style={{ width: "450px" }}
            >
              <b>LGS Staff Management Services Incorporated</b> is a high
              caliber professional manpower service provider for Hotels &
              Restaurant. We are recognized for our
              <b> quality and efficiency</b> in providing you the manpower, just
              when you need it the most.
            </p>
          </div>

          <div
            className="ms-4 mx-5"
            style={{
              borderLeft: "1px solid #000",
              height: "430px",
              maxHeight: "430px",
            }}
          ></div>

          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="cards d-flex flex-column gap-3 justify-content-center">
              <Link to={`/signin/${isWalkIn}`}>
                <div
                  className="card red shadow d-flex flex-column align-items-center p-4"
                  style={{
                    cursor: "pointer",
                    width: "250px",
                    minHeight: "200px",
                  }}
                >
                  <i
                    className="bi bi-door-open"
                    style={{ fontSize: "2.5em", marginBottom: "15px" }}
                  ></i>
                  <h5 className="card-title">Walk in</h5>
                  <p className="card-text">
                    Walk in and apply for a job directly with us.
                  </p>
                </div>
              </Link>
              <div
                className="card blue shadow d-flex flex-column align-items-center p-4"
                style={{
                  cursor: "pointer",
                  width: "250px",
                  minHeight: "200px",
                }}
                onClick={this.others.bind(this)}
              >
                <i
                  className="bi bi-three-dots"
                  style={{ fontSize: "2.5em", marginBottom: "15px" }}
                ></i>
                <h5 className="card-title">Others</h5>
                <p className="card-text">
                  For individuals with other inquiries.
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(OptionCardsPage);
